import { CalendarDays } from "lucide-react";

const AttendanceTileDesign = {
  id: "attendance",
  icon: CalendarDays,
  label: "Attendance",
  background: "linear-gradient(135deg, var(--color-primary-dark), var(--color-primary))",
  color: "#ffffff",
};

export default AttendanceTileDesign;
